
export const goals = {
  // Goals Page
  goalsPageTitle: 'Goals',
  goals: 'My Goals',
  rewards: 'Rewards',
  analytics: 'Analytics',
  noGoals: 'No goals found',
  noGoalsYet: 'No goals yet',
  addGoal: 'Add Goal',
  editGoal: 'Edit Goal',
  deleteGoal: 'Delete Goal',
  filterGoals: 'Filter Goals',
  clearFilters: 'Clear Filters',
  searchGoals: 'Search goals...',
  total: 'Total',
  loading: 'Loading...',
  status: 'Status',
  
  // Goal Details
  goalDetails: 'Goal Details',
  overview: 'Overview',
  progress: 'Progress',
  viewDetails: 'View Details',
  duplicate: 'Duplicate Goal',
  close: 'Close',
  
  // Goal Statuses
  todo: 'To Do',
  inProgress: 'In Progress',
  done: 'Done',
  allStatuses: 'All Statuses',
  selectStatus: 'Select Status',
  
  // Categories
  categories: 'Categories',
  category: 'Category',
  addCategory: 'Add Category',
  editCategory: 'Edit Category',
  deleteCategory: 'Delete Category',
  categoryName: 'Category Name',
  categoryColor: 'Category Color',
  noCategoriesFound: 'No categories found',
  selectCategory: 'Select a category',
  createNewCategory: 'Create New Category',
  allCategories: 'All Categories',
  noCategory: 'No Category',
  
  // Goal Form
  goalTitle: 'Title',
  dueDate: 'Due Date',
  dueDateFrom: 'Due Date From',
  dueDateTo: 'Due Date To',
  resources: 'Resources',
  knowledge: 'Knowledge',
  contacts: 'Contacts',
  notes: 'Notes',
  cancel: 'Cancel',
  addResource: 'Add Resource',
  addKnowledge: 'Add Knowledge',
  addContact: 'Add Contact',
  selectDate: 'Select Date',
  selectDueDate: 'Select Due Date',
  
  // Resources, Knowledge, Contacts
  noResources: 'No resources added yet',
  noKnowledge: 'No knowledge items added yet',
  noContacts: 'No contacts added yet',
  addNotes: 'Add notes here...',
  copy: 'Copy',
  
  // Notifications
  goalCreated: 'Goal created successfully',
  goalUpdated: 'Goal updated successfully',
  goalDeleted: 'Goal deleted successfully',
  categoryCreated: 'Category created successfully',
  categoryUpdated: 'Category updated successfully',
  categoryDeleted: 'Category deleted successfully',
  
  // Confirmations
  confirmDeleteGoal: 'Are you sure you want to delete this goal?',
  confirmDeleteCategory: 'Are you sure you want to delete this category?',
  
  // Validation
  titleRequired: 'Title is required',
  dueDateRequired: 'Due date is required',
  dueDateInvalid: 'Due date must be today or later',
  categoryNameRequired: 'Category name is required',
  categoryColorRequired: 'Category color is required',
  
  // Authentication
  authRequired: 'Authentication Required',
  pleaseLoginToViewGoals: 'Please log in to view and manage your goals',
  
  // Additional properties
  save: 'Save',
};
